import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLock = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.3333 7.33333V5.33333C11.3333 3.49238 9.84095 2 8 2C6.15905 2 4.66667 3.49238 4.66667 5.33333V7.33333M5.46667 14H10.5333C11.6534 14 12.2135 14 12.6413 13.782C13.0177 13.5903 13.3236 13.2843 13.5154 12.908C13.7333 12.4801 13.7333 11.9201 13.7333 10.8V10.5333C13.7333 9.41323 13.7333 8.85318 13.5154 8.42535C13.3236 8.04903 13.0177 7.74307 12.6413 7.55132C12.2135 7.33333 11.6534 7.33333 10.5333 7.33333H5.46667C4.34656 7.33333 3.78651 7.33333 3.35869 7.55132C2.98236 7.74307 2.6764 8.04903 2.48465 8.42535C2.26667 8.85318 2.26667 9.41323 2.26667 10.5333V10.8C2.26667 11.9201 2.26667 12.4801 2.48465 12.908C2.6764 13.2843 2.98236 13.5903 3.35869 13.782C3.78651 14 4.34656 14 5.46667 14Z",
		stroke: "currentColor",
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgLock;
